// Resolve an instruction-screen code (M0, M1, M2, M3, M4, M5, M6, P0, S0) to its
// verbatim blockquote text from instruction_screens.md.
import { INSTRUCTION_SCREENS_MD } from './canonicalContent.generated'
import { SCREENING_OVERVIEW, SCREENING_NEXT } from './screeningScreens'
import { M0, M1 } from './mainScreens'

const lines = INSTRUCTION_SCREENS_MD.split('\n')

// New or overridden screens live outside the frozen canonical module and resolve by
// name. Checked BEFORE the markdown lookup, so a key here shadows the same-named screen
// in instruction_screens.md — see mainScreens.js for why M0 is shadowed.
const EXTRA_SCREENS = {
  SCREENING_OVERVIEW,
  SCREENING_NEXT,
  M0,
  M1
}

export function screenText (code) {
  if (!code) return ''
  if (EXTRA_SCREENS[code]) return EXTRA_SCREENS[code]
  // Heading looks like: "## M2 · Before each learning task (A1 / B1) — AI available"
  const start = lines.findIndex(l => new RegExp(`^##\\s+${code}\\b`).test(l))
  if (start === -1) return ''
  const out = []
  for (let i = start + 1; i < lines.length; i++) {
    const l = lines[i]
    if (l.startsWith('## ') || l.startsWith('---')) break
    if (l.startsWith('>')) out.push(l.replace(/^>\s?/, ''))
    else if (out.length && l.trim() === '') out.push('')
  }
  // trim leading/trailing blanks
  while (out.length && out[0].trim() === '') out.shift()
  while (out.length && out[out.length - 1].trim() === '') out.pop()
  return out.join('\n')
}

// The second learning task's screen adds one standalone line (spec M2 note).
export const M2B_EXTRA =
  'This task is standalone — everything you need is in its instructions. A fresh AI-tutor conversation starts here.'

// Pull a "☐ ..." pledge/ack line out of screen text, if present.
export function extractCheckbox (text) {
  const m = text.split('\n').find(l => l.trim().startsWith('☐'))
  return m ? m.replace(/^\s*☐\s*/, '').replace(/\*/g, '') : null
}
